import { useParams } from 'react-router-dom';

// The audit app mounts under tinuiti-frontend's company-scoped route
// (`/:company/paid-search-audit/*`). All internal navigation is built relative to this base so
// the ported pages no longer hardcode the prototype's standalone `/away/audits` paths.
export const useAuditBasePath = (): string => {
  const { company } = useParams<{ company: string }>();
  return `/${company}/paid-search-audit`;
};
